import React from 'react';
import styled from 'styled-components';

import PageLayout from '@app/layouts/pageLayout/PageLayout';
import MotionWrapper from '@components/wrapper/MotionWrapper';
import { getPathKey } from '@utils/getPath';
import { useDocument } from '@nandorojo/swr-firestore';
import BackToListBtn from '@components/dataEntry/button/BackBtn/BackToListBtn';
import usePageSet from '@hooks/usePageSet';
import { ItimelineItem } from '@typings/pages/timeline.interface';
import TimelineDetailContents from '@pages/Timeline/TimelineDetail/TimelineDetailContents';
import Theme from '@styles/Theme';
import { useReadPermission } from '@hooks/usePermission';
import { ACCESS_TYPE } from '@typings/common/accessType';
import NoExistPage from '@template/NoExistPage/NoExistPage';
import GuardPage from '@template/PermissionItem/GuardPage';

const Container = styled.div`
  width: 100%;
  max-width: 720px;
  margin: 0 auto;
  display: grid;
  padding: 16px 0;
  gap: 24px;

  @media (max-width: 768px) {
    max-width: 100%;
  }
`;

const BackSec = styled.div`
  width: 100%;
`;

const DetailBox = styled.div`
  border-radius: var(--cardBorderRadius);
  border: 1px solid var(--lineColor);
  background-color: var(--cardBackgroundColor);
  backdrop-filter: blur(4px);
  box-shadow: ${Theme.shadow.card};
`;

type Props = {};
function RollPlayDetail({ }: Props) {
  const collectionPath = getPathKey(1);
  const docId = getPathKey(2);

  const isReplyDetail = collectionPath.includes('Comment');

  // page Setting --------------------------------------------------------
  const { docWidth, docLayout, authorDisplayType, authorAvatarType } = usePageSet({
    collectionPath,
  });

  const { data: boardData } = useDocument<ItimelineItem>(
    `${collectionPath}/${docId}`,
    { listen: true },
  );

  const readPermission = useReadPermission({
    accessType: boardData?.accessType || ACCESS_TYPE.PUBLIC,
    authorUid: boardData?.authorUid || '',
  });

  if (!boardData) return null;

  if (!boardData?.exists) return <NoExistPage />;

  if (!readPermission) return <GuardPage accessType={boardData.accessType} />;

  return (
    <MotionWrapper>
      <PageLayout
        style={{
          maxWidth: docWidth,
          padding: 0,
          height: 'fit-content',
        }}
      >
        <Container>
          <BackSec>
            <BackToListBtn
              handleClick={() => history.back()}
              style={{
                backgroundColor: 'var(--cardBackgroundColor)',
                color: 'var(--textColor)',
              }}
              IconColor={'var(--textColor)'}
            />
          </BackSec>
          <DetailBox>
            <TimelineDetailContents
              boardData={boardData}
              docId={docId}
              collectionPath={collectionPath}
              isRelateBoard={false}
              authorDisplayType={authorDisplayType}
              authorAvatarType={authorAvatarType}
            />
          </DetailBox>
        </Container>
      </PageLayout>
    </MotionWrapper>
  );
}

export default RollPlayDetail;
